import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Megaphone, Shield, LogOut } from "lucide-react";

const LINKS = [
  { to: "/", label: "Bandeaux", Icon: LayoutGrid, testid: "nav-banners", match: ["/", "/banner"] },
  { to: "/posters", label: "Affiches", Icon: Megaphone, testid: "nav-posters", principal: true, match: ["/posters", "/poster/"] },
  { to: "/admin", label: "Administration", Icon: Shield, testid: "nav-admin", principal: true, match: ["/admin"] },
];

const isActive = (path, match) => match.some((m) => (m === "/" ? path === "/" : path.startsWith(m)));

export const AppNav = () => {
  const { user, logout } = useAuth();
  const path = window.location.pathname;
  const links = LINKS.filter((l) => !l.principal || user?.role === "principal");
  return (
    <nav className="sticky top-0 z-40 h-11 border-b border-border bg-background/95 backdrop-blur-xl" data-testid="app-nav">
      <div className="mx-auto flex h-full max-w-7xl items-center gap-1 px-2 sm:px-6 lg:px-8">
        {links.map(({ to, label, Icon, testid, match }) => (
          <NavLink key={to} to={to} data-testid={testid}
            className={`flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold transition-colors sm:text-sm ${isActive(path, match) ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
            <Icon className="h-4 w-4" /> {label}
          </NavLink>
        ))}
        <button onClick={logout} title="Déconnexion" data-testid="nav-logout"
          className="ml-auto flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground sm:text-sm">
          <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Déconnexion</span>
        </button>
      </div>
    </nav>
  );
};
